import React, { useState, useMemo } from "react";
import { FaEdit, FaCheck, FaBan, FaKey } from "react-icons/fa";
import UserEdit from "./UserEdit";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePut } from "../../customHooks/usePut";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';

import { FaEye, FaEyeSlash } from "react-icons/fa";

function UsersTable({ users: initialUsers, updateUser, refetch }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState(initialUsers);
  const { executePut } = usePut();
  const [userForPassword, setUserForPassword] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  const totalPages = Math.ceil(users.length / usersPerPage);

  const handleOpenEdit = (user) => setSelectedUser(user);
  const handleCloseEdit = () => setSelectedUser(null);

const [showPassword, setShowPassword] = useState(false);




  const handleOpenPasswordModal = (user) => {
    setUserForPassword(user);
    setNewPassword("");
  };

  const handleClosePasswordModal = () => {
    setUserForPassword(null);
    setNewPassword("");
  };

  const handleChangePassword = async () => {
    if (!newPassword.trim()) {
      alert("La contraseña no puede estar vacía.");
      return;
    }

    try {
      const response = await executePut(
        `https://ectech-software.com.ar/api/core/users/${userForPassword.id}/change-password`,
        { password: newPassword }
      );

      if (!response) throw new Error("No se pudo cambiar la contraseña.");

     toast.success("Contraseña actualizada correctamente.");
      handleClosePasswordModal();
    } catch (error) {
      console.error("Error al cambiar la contraseña:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const handleToggleStatus = async (user) => {
    try {
      const updatedUser = {
        username: user.username,
        password: user.password,
        status: !user.status,
        userData: {
          name: user.userData?.name ?? "",
          lastname: user.userData?.lastname ?? "",
          email: user.userData?.email ?? "",
          telephone: user.userData?.telephone ?? "",
          address: user.userData?.address ?? "",
          postalCode: user.userData?.postalCode ?? "",
          locality: { id: user.userData?.locality?.id ?? null },
        },
        roles: user.roles ?? [],
      };

      const response = await executePut(
        `https://ectech-software.com.ar/api/core/users/${user.id}`,
        updatedUser
      );

      if (!response) throw new Error("No se pudo actualizar el estado del usuario.");

      setUsers((prevUsers) =>
        prevUsers.map((u) => (u.id === user.id ? { ...u, status: updatedUser.status } : u))
      );

      updateUser({ ...user, status: updatedUser.status });

    } catch (error) {
      console.error("Error al actualizar el estado del usuario:", error);
      alert(`Error al cambiar el estado del usuario: ${error.message}`);
    }
  };

  const paginatedUsers = useMemo(() => {
    const start = (currentPage - 1) * usersPerPage;
    return users.slice(start, start + usersPerPage);
  }, [users, currentPage]);

  const userRows = useMemo(() => {
    return paginatedUsers.map((user) => (
      <UserRow
        key={user.id}
        user={user}
        onEdit={() => handleOpenEdit(user)}
        onToggleStatus={() => handleToggleStatus(user)}
        onChangePassword={() => handleOpenPasswordModal(user)}
      />
    ));
  }, [paginatedUsers]);

  return (
    <div className="container mt-4" aria-live="polite">
      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th>Usuario de Sistema</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              userRows
            ) : (
              <tr>
                <td colSpan="8" className="text-center">No hay usuarios disponibles</td>
              </tr>
            )}
          </tbody>
        </table>

        <nav className="d-flex justify-content-center mt-3">
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Anterior
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index}
                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
              >
                <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Siguiente
              </button>
            </li>
          </ul>
        </nav>
      </div>

      {selectedUser && (
        <div className="user-edit-container">
          <UserEdit
            user={selectedUser}
            setShowForm={handleCloseEdit}
            updateUser={updateUser}
            refetch={refetch}
          />
        </div>
      )}

     {userForPassword && (
  <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Cambiar contraseña</h5>
          <button type="button" className="btn-close" onClick={handleClosePasswordModal}></button>
        </div>
        <div className="modal-body">
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={6}
              required
            />
            <span className="input-group-text" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={handleClosePasswordModal}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleChangePassword}>Guardar</button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

const UserRow = React.memo(({ user, onEdit, onToggleStatus, onChangePassword }) => {
  const userStatus = user.status ? "Activo" : "Inactivo";
  const statusClass = user.status ? "text-success fw-bold" : "text-danger fw-bold";
  const userRole = user.roles?.length > 0 ? user.roles[0].name : "Sin rol";

  let roleClass = "text-dark";
  if (userRole.toLowerCase() === "escuela") {
    roleClass = "text-primary";
  } else if (userRole.toLowerCase() === "administrador") {
    roleClass = "text-danger";
  }

  return (
    <tr>
      <td>{user.username}</td>
      <td>{user.userData?.name ?? "Sin nombre"}</td>
      <td>{user.userData?.lastname ?? "Sin apellido"}</td>
      <td>{user.userData?.email ?? "Sin email"}</td>
      <td>{user.userData?.telephone ?? "Sin teléfono"}</td>
      <td className={roleClass}>{userRole}</td>
      <td className={statusClass}>{userStatus}</td>
      <td className="text-center">
        <button
          onClick={() => onToggleStatus(user)}
          className={`btn ${user.status ? "btn-danger" : "btn-success"} me-2`}
          aria-label={user.status ? "Desactivar usuario" : "Activar usuario"}
        >
          {user.status ? <FaBan /> : <FaCheck />}
        </button>
        <button
          onClick={onEdit}
          className="btn btn-warning me-2"
          aria-label="Editar usuario"
        >
          <FaEdit />
        </button>
        <button
          onClick={() => onChangePassword(user)}
          className="btn btn-primary me-2"
          aria-label="Actualizar Contraseña"
        >
          <FaKey />
        </button>
      </td>
    </tr>
  );
  <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
});

export default UsersTable;
